module.exports = {"svg":{"$":{"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 16 16"},"title":["UI_Export_16"],"path":[{"$":{"d":"M3,13H6v2H1V1H6V3H3ZM15,8,9,3.5V6H5v4H9v2.5Z","fill":"#464646"}}]}}


//////////////////
// WEBPACK FOOTER
// ./node_modules/xml-loader!./src/svg/UI_Export_16.svg
// module id = ONMb
// module chunks = 1